import { Interest } from 'types/interest'

export interface InterestReducer {
  interests: Interest[]
}
const defaultState: InterestReducer = {
  interests: [
    { icon: "", title: "Class"},
    { icon: "", title: "Workshop"},
    { icon: "", title: "Party"},
    { icon: '', title: "Social" },
    { icon: '', title: "Salsa" },
    { icon: '', title: "Bachata" },
    { icon: '', title: "Kizomba" },
    { icon: '', title: "Tango" },
    { icon: '', title: "Ballroom" },

    // { icon: '', title: "Ballet" },
    { icon: '', title: "Hip hop" },
    // { icon: '', title: "Tap dance" },
    { icon: '', title: "Swing" },
    // { icon: '', title: "Jazz" },
    // { icon: '', title: "Modern" },
    // { icon: '', title: "Waltz" },
    { icon: '', title: "Breaking" },
    // { icon: '', title: "Cha-cha-cha" },
    // { icon: '', title: "Samba" },
    // { icon: '', title: "Rumba" },
    // { icon: '', title: "Polka" },
    { icon: '', title: "Flamenco" },
    { icon: '', title: "Belly dance" },
    { icon: '', title: "Mambo" },
    // { icon: '', title: "Charleston" },
    // { icon: '', title: "Lindy Hop" },
    // { icon: '', title: "Foxtrot" },
    // { icon: '', title: "Bolero" },
    // { icon: '', title: "Latin" },
    // { icon: '', title: "Pole" },
    // { icon: '', title: "Irish" },
    // { icon: '', title: "Disco" },
    // { icon: 'cooking.svg', title: 'food' },
    // { icon: 'music.svg', title: 'music' },
    // { icon: 'camera.svg', title: 'movies' },
    // { icon: 'football.svg', title: 'sport' },
    // { icon: 'swimming.svg', title: 'swimming' },
    // { icon: 'gaming.svg', title: 'gaming' },
    // { icon: 'luggage.svg', title: 'shopping' },
    // { icon: 'books.png', title: 'reading' },
    // { icon: 'design.svg', title: 'design' },

    // { icon: 'walking.svg', title: 'walking' },
    // { icon: 'photography.svg', title: 'photography' },
    // { icon: 'language.svg', title: 'language' },
    // { icon: 'diy.svg', title: 'DIY' },
    // { icon: 'business.svg', title: 'business' },
    // { icon: 'technology.svg', title: 'technology' },
    { icon: '', title: "Other" },

  ],
}

export default function interest(state = defaultState, action: any) {
  switch (action.type) {
    // case 'UPDATE_INTERESTS':
    //   return Object.assign({}, state, { interests: action.interests })
    // case 'UPDATE_MY_INTERESTS':
    //   return Object.assign({}, state, { myInterests: action.myInterests })

    default:
      if (action?.response?.code === 'FORCE_LOGOUT_FRONTEND') return defaultState
      return state
  }
}
